<template>
<div class="route-loader">
    <div v-if="_bg" class="route-loader-bg">
    </div>
    <div class="route-loader-animation">
        <img :width="_width" :height="_height" :src="src" alt="Online ADA Shield"/>
    </div>
</div>
</template>

<script>
export default {
    name: 'RouteLoader',
    data: () => ({
        src: "/assets/onlineada_badge_logo.png"
    }),
    computed: {
        _bg() {
            if(this.bg == 'off') return false  
            return true
        },
        _width() {
            if(this.width) return this.width
            return '200px';
        },
        _height() {
            if(this.height) return this.height
            return 'auto';
        },
    },
    props: ['width','height','bg'],
    methods: {
    },
    created() {
    },
    mounted() {
    },
    components: {
    },
}
</script>
<style>
.route-loader {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1;
    display:flex;
    justify-content: center;
    align-items: center;
}
.route-loader-bg {
    position: absolute;
    width: 97%;
    height: 97%;
    background-color: rgba(0,0,0,.5);
    z-index: 1;
}
.route-loader-animation {
    z-index: 1;
}
.route-loader-animation img {
    transform: scale(1);
    animation: pulse 1.5s ease-in-out infinite;
    animation-direction: alternate;
}
@-webkit-keyframes pulse {
    0% {
        transform: scale(.75);
    }
    100% {
        transform: scale(1);
    }
}
@keyframes pulse {
    0% {
        transform: scale(.75);
    }
    100% {
        transform: scale(1);
    }
}
</style>
